import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Card,
    CardContent,
    CircularProgress,
    Backdrop,
    Fade,
    IconButton,
    Typography,
    Modal,
    Button,
    LinearProgress,
    Chip,
    withStyles
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { DownloadOutlined } from '@ant-design/icons';
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import RefreshIcon from "@material-ui/icons/Refresh";
import SourceIcon from "@material-ui/icons/TrackChanges";
import FilterListIcon from "@material-ui/icons/FilterList";
import BarChartIcon from "@material-ui/icons/BarChart";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CategoryIcon from "@material-ui/icons/Category";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { useDispatch } from "react-redux";
import { setLSTData } from "../../redux/actions/leadSourceActions";

// Column labels of the lead-detail modal table. Declared once so the header,
// the skeleton rows and every colSpan share one source of truth - they had
// already drifted (skeleton rendered 18 cells against a 19-column header).
const MODAL_COLUMNS = [
    "#",
    "Project No",
    "Lead No",
    "Created At",
    "Lead Assigned Date",
    "Client",
    "Source Name",
    "Secondary Source",
    "Source Type",
    "Value (INR)",
    "City",
    "Exp Center",
    "Meeting Date",
    "Lead Won Date",
    "Department",
    "Current Stage",
    "Lead Type",
    "Junk Reason",
    "Move To Marketing Reason",
    "Move To Marketing Other Reason",
];

const ORANGE = "#F47E46";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#f2994a";

// Indeterminate bar shown inside whichever card is loading. Matches the page's
// orange accent so the two read as the same system.
const BrandLinearProgress = withStyles(() => ({
    root: { height: 4, borderRadius: 999, backgroundColor: "rgba(244,126,70,0.14)" },
    bar: { borderRadius: 999, background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, ${ORANGE_LIGHT})` },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    // Reserved slot rather than a conditional element, so the layout doesn't
    // jump by 4px every time a fetch starts.
    progressSlot: {
        height: 4,
        borderRadius: 999,
        overflow: "hidden",
        margin: "0 0 14px",
    },
    // Filters stay readable but visibly out of action while data loads.
    filterBlock: {
        transition: "opacity .2s ease",
    },
    loadingChip: {
        marginLeft: "auto",
        height: 22,
        fontSize: 11,
        fontWeight: 700,
        background: "#FFF1EA",
        color: ORANGE_DARK,
        border: `1px solid ${ORANGE}44`,
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": {
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white !important',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
            borderRadius: '20px'
        },
    },
    cell: {
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
        color: "#fff",
        textAlign: "center",
        fontSize: 13
    },
    // --- Redesign additions below ---
    pageRoot: {
        padding: "4px 2px 24px",
    },
    headerBanner: {
        display: "flex",
        alignItems: "center",
        gap: 18,
        padding: "24px 28px",
        borderRadius: 20,
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 60%, #2a78d6 100%)",
        color: "#fff",
        boxShadow: "0 8px 24px rgba(28,55,93,0.18)",
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: { padding: "18px 18px", borderRadius: 16 },
    },
    headerIconWrap: {
        width: 52,
        height: 52,
        borderRadius: 14,
        background: "rgba(255,255,255,0.16)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    headerTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: "#fff",
        lineHeight: 1.2,
    },
    headerSubtitle: {
        fontSize: 13,
        color: "rgba(255,255,255,0.82)",
        marginTop: 2,
    },
    filterCard: {
        borderRadius: 16,
        marginBottom: 20,
        boxShadow: "0 2px 12px rgba(28,55,93,0.06)",
        border: "1px solid #eceff3",
    },
    sectionLabel: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        fontWeight: 700,
        color: "#8593a8",
        textTransform: "uppercase",
        letterSpacing: 0.6,
        marginBottom: 14,
    },
    roundedField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 14,
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2a5ea8",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2a5ea8",
        },
    },
    pillButton: {
        borderRadius: 24,
        textTransform: "none",
        fontWeight: 600,
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    },
    dashboardCard: {
        borderRadius: 16,
        border: "1px solid #eceff3",
        boxShadow: "0 2px 12px rgba(28,55,93,0.06)",
        marginBottom: 20,
        overflow: "hidden",
    },
    dashboardCardHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        padding: "16px 22px",
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
    },
    dashboardCardTitle: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        color: "#fff",
        fontWeight: 700,
        fontSize: 17,
    },
    statsStrip: {
        display: "flex",
        flexWrap: "wrap",
        gap: 14,
        padding: "16px 22px",
        background: "#f7f9fc",
        borderBottom: "1px solid #eceff3",
    },
    statChip: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 18px",
        borderRadius: 14,
        background: "#fff",
        border: "1px solid #eceff3",
        boxShadow: "0 2px 8px rgba(28,55,93,0.05)",
        minWidth: 150,
    },
    statChipIcon: {
        width: 34,
        height: 34,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    statChipValue: {
        fontSize: 18,
        fontWeight: 700,
        color: "#1C375D",
        lineHeight: 1.1,
    },
    statChipLabel: {
        fontSize: 11,
        color: "#8593a8",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: 0.4,
    },
    countBadge: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 30,
        padding: "3px 10px",
        borderRadius: 12,
        fontWeight: 700,
        fontSize: 13,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    tableScrollArea: {
        // stickyHeader on <Table> only has something to stick against when
        // this scrolls internally - keeping the boundary here (not on an
        // ancestor wrapping other controls) means only the rows scroll
        // under the pinned header/left column.
        maxHeight: "62vh",
        overflow: "auto",
        borderRadius: "0 0 16px 16px",
    },
    '@keyframes spin': {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    spinningIcon: {
        animation: "$spin 1s linear infinite",
    },
}));

const headerStyle = {
    background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
    color: "#fff",
    fontWeight: 600,
    textAlign: "center",
    fontSize: 14,
    border: "1px solid #cfd8dc",
    // stickyHeader-equivalent for a plain <TableCell style={...}> - pins the
    // column-title row while tableScrollArea scrolls underneath it.
    position: "sticky",
    top: 0,
    zIndex: 4,
};

const iconHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6
};

const rowStyle = {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #eee",
    transition: "background-color .15s ease",
};

const cellStyle = {
    textAlign: "center",
    cursor: "pointer",
    fontSize: 14,
    background: "white",
    border: "1px solid #cfd8dc",
    transition: "background-color .15s ease",
};

const monthCellStyle = {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
    color: "#fff",
    textAlign: "center",
    fontWeight: 700,
    paddingLeft: 16,
    border: "1px solid #cfd8dc",
};

const totalRowStyle = {
    backgroundColor: "#e8edf7"
};

const totalCellStyle = {
    textAlign: "center",
    cursor: "pointer",
    color: "#fff",
    zIndex: 1,
    textDecoration: "underline",
    fontWeight: "bolder",
    background: "linear-gradient(135deg, #219150 0%, #27ae60 100%)",
    border: "1px solid #cfd8dc"
};

const totalMonthCellStyle = {
    position: 'sticky',
    left: 0,
    bottom: 0,
    zIndex: 5,
    background: "linear-gradient(135deg, #219150 0%, #27ae60 100%)",
    color: "#fff",
    textAlign: "center",
    fontWeight: 700,
    paddingLeft: 16,
    border: "1px solid #cfd8dc",
};


const SourceOfLeadsDashboard = (props) => {
    const classes = useStyles();
    const lstData = useSelector((state) => state.leadSource.lstData);
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [sourceOfLeadsData, setSourceOfLeadsData] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "", dateType: "leadAssignedDate" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("0");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    // Drives just the modal's own body instead of the app-wide loading
    // overlay - the modal opens immediately on click and shows this spinner
    // in place of the table until the leads for that cell arrive.
    const [modalDataLoading, setModalDataLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [sourceOfLeadsTableCsvData, setSourceOfLeadsTableCsvData] = useState([]);
    const sourceOfLeadsTableCsvButtonRef = useRef(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const [leadMode, setLeadMode] = useState("All")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']


    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const EIGHTH_BUTTON_DISABLE_UNTIL_KEY = 'eighthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [search, setSearch] = useState("");

    const [selectedTitle, setSelectedTitle] = useState("");

    // `secondarySources` is an ARRAY of { source, date } on the Lead (see
    // models/lead.js) - a lead can pick up more than one over its life - so the
    // entries are joined rather than read off a single field, and each name
    // carries its own date. A separate date column is not an option: with
    // several sources per lead the date has to travel beside the name it
    // belongs to. Entries whose source never populated are dropped instead of
    // rendering as blanks.
    const formatSecondarySources = (lead, fallback = "NA") => {
        const entries = (lead?.secondarySources || [])
            .filter((entry) => entry?.source?.name)
            .map((entry) => {
                const on = entry?.date ? moment.utc(entry.date).format("DD-MM-YYYY") : "";
                return on ? `${entry.source.name} (${on})` : entry.source.name;
            });
        return entries.length ? entries.join(", ") : fallback;
    };

    const formatDate = (date) =>
        date ? moment.utc(date).format("DD-MM-YYYY") : "-";

    const getProposeMeetingDate = (lead) =>
        lead?.salesStageData?.qtSentMeetingDetail?.proposeMeetingDate ?? null;

    useEffect(() => {
        expCenters();
        locations();
        sourceOfLeadsDashboard();
    }, []);
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "_id", label: "Lead Id" },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "sourceName", label: "Source Name" },
        { key: "secondarySourceOfLead", label: "Secondary Source Of Lead" },
        { key: "sourceType", label: "Source Type" },
        { key: "pageURL", label: "Page URL" },
        { key: "clientName", label: "Client Name" },
        // { key: "clientNumber", label: "Client Number" },
        // { key: "clientEmail", label: "Client Email" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Experience Center" },
        { key: "meetingDate", label: "Meeting Date" },
        { key: "leadWonDate", label: "Lead Won Date" },
        { key: "department", label: "Department" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
        { key: "junkReason", label: "Junk Reason" },
        { key: "moveToMarketingReason", label: "Move To Marketing Reason" },
        { key: "moveToMarketingOtherReason", label: "Move To Marketing Other Reason" },
        { key: "ad_id", label: "ad_id" },
        { key: "adset_id", label: "adset_id" },
        { key: "campaign_id", label: "campaign_id" },
        { key: "projectNeeds", label: "SOW" },
        { key: "threeLakhsSuits", label: "Three Lakh Suits" },
        { key: "startProjectBy", label: "Start Project By" },

    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    _id: popMonthData[i]?._id || "NA",
                    projectCode: popMonthData[i]?.erpProjectNo || "NA",
                    leadNumber: popMonthData[i]?.lead_no || "NA",
                    createdAt: popMonthData[i]?.createdAt
                        ? formatDate(popMonthData[i]?.createdAt)
                        : "NA",
                    leadAssignedDate: popMonthData[i]?.leadAssignedDate
                        ? formatDate(popMonthData[i]?.leadAssignedDate)
                        : "NA",
                    sourceName: popMonthData[i]?.sourceOfLead?.name || "NA",
                    secondarySourceOfLead: formatSecondarySources(popMonthData[i]),
                    sourceType: popMonthData[i]?.sourceOfLead?.sourceType || "NA",
                    pageURL: popMonthData[i]?.pageURL ? popMonthData[i]?.pageURL : "NA",
                    clientName: popMonthData[i]?.customerId?.name || "NA",
                    // clientNumber: popMonthData[i]?.customerId?.contact_no || "NA",
                    // clientEmail: popMonthData[i]?.customerId?.email || "NA",
                    totalValue:
                        (popMonthData[i].staticSalesWonBudget),
                    location: popMonthData[i]?.experienceCenterId?.locationId ? popMonthData[i]?.experienceCenterId?.locationId?.name : "NA",
                    expCtrName: popMonthData[i]?.experienceCenterId ? popMonthData[i]?.experienceCenterId?.name : "NA",
                    meetingDate: getProposeMeetingDate(popMonthData[i])
                        ? formatDate(getProposeMeetingDate(popMonthData[i]))
                        : "NA",
                    leadWonDate: popMonthData[i]?.leadWonDate
                        ? formatDate(popMonthData[i]?.leadWonDate)
                        : "NA",
                    department: popMonthData[i]?.departmentId?.name ? popMonthData[i]?.departmentId?.name : 'NA',
                    currentStage: popMonthData[i].currentStage ? popMonthData[i]?.currentStage : 'NA',
                    leadType: popMonthData[i]?.leadType || "NA",
                    junkReason: popMonthData[i]?.junkReason || "NA",
                    moveToMarketingReason: popMonthData[i]?.moveToMarketingReason || "NA",
                    moveToMarketingOtherReason: popMonthData[i]?.moveToMarketingOtherReason || "NA",
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",


                    internalDesignSignOffDate: popMonthData[i]?.internalDesignSignOffDate
                        ? moment(popMonthData[i]?.internalDesignSignOffDate).format("DD-MM-YYYY")
                        : "NA",
                    designSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "NA",
                    materialDeliveryDate: popMonthData[i]?.materialDispatchedDate
                        ? moment(popMonthData[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "NA",
                    actualCompletionDate: popMonthData[i]?.executionCompletionDate
                        ? moment(popMonthData[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "NA",
                    ad_id: popMonthData[i]?.ad_id !== null ? popMonthData[i]?.ad_id : "NA",
                    adset_id: popMonthData[i]?.adset_id !== null ? popMonthData[i]?.adset_id : "NA",
                    campaign_id: popMonthData[i]?.campaign_id !== null ? popMonthData[i]?.campaign_id : "NA",
                    projectNeeds: popMonthData[i]?.projectNeeds || "NA",
                    threeLakhsSuits: popMonthData[i]?.threeLakhsSuits || "NA",
                    startProjectBy: popMonthData[i]?.startProjectBy || "NA",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     internalDesignSignOffDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("csvDownloadHandler error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "sourceOfLead", label: "Source of Lead" },
        { key: "secondarySourceOfLead", label: "Secondary Source of Lead" },
        { key: "clientName", label: "Client Name" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "meetingDate", label: "Meeting Date" },
        { key: "leadWonDate", label: "Lead Won Date" },
        { key: "department", label: "Current Department" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
    ];

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    createdAt: popMonthData[i]?.createdAt ? formatDate(popMonthData[i]?.createdAt) : "-",
                    leadAssignedDate: popMonthData[i]?.leadAssignedDate ? formatDate(popMonthData[i]?.leadAssignedDate) : "-",
                    sourceOfLead: popMonthData[i]?.sourceOfLead?.name || "N/A",
                    secondarySourceOfLead: formatSecondarySources(popMonthData[i], "N/A"),
                    clientName: popMonthData[i]?.customerId?.name || "N/A",
                    valueInr: popMonthData[i]?.staticSalesWonBudget || "N/A",
                    location: popMonthData[i]?.experienceCenterId?.locationId
                        ? popMonthData[i]?.experienceCenterId?.locationId?.name
                        : "Others",
                    expCtrName: popMonthData[i]?.experienceCenterId
                        ? popMonthData[i]?.experienceCenterId?.name
                        : "Others",
                    meetingDate: getProposeMeetingDate(popMonthData[i])
                        ? formatDate(getProposeMeetingDate(popMonthData[i]))
                        : "-",
                    leadWonDate: popMonthData[i]?.leadWonDate
                        ? formatDate(popMonthData[i]?.leadWonDate)
                        : "-",
                    department: popMonthData[i]?.departmentId?.name || "N/A",
                    currentStage: popMonthData[i]?.currentStage || "N/A",
                    leadType: popMonthData[i]?.leadType || "N/A",
                };
                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const sourceOfLeadsDashboard = async (addLocation, addExpCenter) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let currentObj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        };
        let shouldMakeApiCall = false;

        // Case 1: No lgdData - must call API
        if (!lstData || lstData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getSourceOfLeadsDashboard(currentObj);
                setSourceOfLeadsData(response.data);
                dispatch(setLSTData(response.data));
            } else {
                // Use existing data
                setSourceOfLeadsData(lstData);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        // try {
        //     let response = await HttpService.getSourceOfLeadsDashboard(currentObj);
        //     setSourceOfLeadsData(response.data);
        // } catch (error) {
        //     props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        // }
        setLoading(false);
    };

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(EIGHTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(EIGHTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(EIGHTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(EIGHTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData(selectedLocation, selectedExperienceCenter);
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    const getRefreshedData = async (addLocation, addExpCenter) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        };
        setLoading(true);
        try {
            let response = await HttpService.getSourceOfLeadsDashboard(obj);
            setSourceOfLeadsData(response.data);
            dispatch(setLSTData(response.data));
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        setLoading(false);
    };

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: event.target.value !== "" ? event.target.value : "",
            selectedLeadMode: leadMode ? leadMode : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getSourceOfLeadsDashboard(obj);
            setSourceOfLeadsData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleLeadMode = async (event) => {
        setLeadMode(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            moveToMarketing: selectedValue !== "" ? selectedValue : "",
            selectedLeadMode: event.target.value ? event.target.value : "All",
        }
        setLoading(true);
        try {
            let response = await HttpService.getSourceOfLeadsDashboard(obj);
            setSourceOfLeadsData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        sourceOfLeadsDashboard(selectedLocation, selectedExperienceCenter)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        setLoading(true);
        await sourceOfLeadsDashboard(selectedLocation, newvalue)
        setLoading(false);
    }

    const handleMultipleLocationData = (e, newvalue) => {
        setSelectedLocation(newvalue)
        handleLocationData(newvalue)
    }
    const handleLocationData = async (newvalue) => {
        // props.setLoading(true);
        await sourceOfLeadsDashboard(newvalue, selectedExperienceCenter)
        // props.setLoading(false);
    }
    const getDataBasedOnClickSourceOfLeads = async (e, month, innerEl, ids, val) => {
        let obj = {}
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        setSelectedTitle(innerEl.sourceType);
        if (val === 'leads') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                userLocation: userDetails.selectedLocation,
                userExpCenter: userDetails.experienceCenterId,
                sourceType: innerEl.sourceType,
                moveToMarketing: selectedValue !== "" ? selectedValue : "",
                selectedLeadMode: leadMode ? leadMode : "All",
                leadIds: ids
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedLocation: locationData,
                    selectedExperienceCenter: expCenterData,
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    sourceType: innerEl.sourceType,
                    moveToMarketing: selectedValue !== "" ? selectedValue : "",
                    selectedLeadMode: leadMode ? leadMode : "All",
                    leadIds: ids
                }
            } else {
                let expCenter;
                for (let i = 0; i < sourceOfLeadsData.length; i++) {
                    if (sourceOfLeadsData[i].experienceCenterName === innerEl) {
                        expCenter = sourceOfLeadsData[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedLocation: locationData,
                    selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    sourceType: innerEl.sourceType,
                    moveToMarketing: selectedValue !== "" ? selectedValue : "",
                    selectedLeadMode: leadMode ? leadMode : "All",
                    leadIds: ids
                }
            }
        }
        // Open the modal right away and let it show its own loader, instead
        // of blocking the click behind the app-wide overlay until data
        // arrives - feels immediate, and the modal communicates its own state.
        setPopMonthData([]);
        setShowDetailedModal(true);
        setModalDataLoading(true);
        try {
            let response = await HttpService.getDataBasedClickSourceOfLead(obj);
            setPopMonthData(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setModalDataLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }


    const handleCloseModal = () => {
        setShowDetailedModal(false);
        setPage(0);
        setSearch("")
    };

    // Function to generate CSV data from the source of leads table - matching exact table structure
    const generateSourceOfLeadsTableCsv = () => {
        try {
            if (!sourceOfLeadsData || sourceOfLeadsData.length === 0 || !sourceOfLeadsData[0]?.monthlyData) {
                setSourceOfLeadsTableCsvData([]);
                return;
            }

            // Create rows for each month - matching exact table structure
            const csvRows = sourceOfLeadsData[0].monthlyData.map((month) => {
                const row = {};
                row["Source Of Leads Month"] = `${month.monthName.slice(0, 3)}-${month.year % 100} `;

                // Add data for each source of lead - matching exact table display
                sourceOfLeadsData.forEach((source) => {
                    const count = source.monthlyData.find(
                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                    )?.createdCount || 0;
                    row[source.sourceType] = count; // Match table display (no formatting in table for monthly rows)
                });

                return row;
            });

            // Add Grand Total row - matching exact table calculation
            const grandTotalRow = {};
            grandTotalRow["Source Of Leads Month"] = "Grand Total";

            // Calculate totals for each source - matching exact table calculation
            sourceOfLeadsData.forEach((source) => {
                // Match exact calculation from table: sourceOfLeadsData.reduce((total, el) => total + (el.sourceType === source.sourceType ? el.monthlyData.reduce((sum, data) => sum + data.createdCount, 0) : 0), 0)
                const total = sourceOfLeadsData.reduce((total, el) => {
                    return total + (el.sourceType === source.sourceType ? el.monthlyData.reduce((sum, data) => sum + data.createdCount, 0) : 0);
                }, 0);
                grandTotalRow[source.sourceType] = formatNumberToTwoDecimalPlaces(total);
            });

            csvRows.push(grandTotalRow);
            setSourceOfLeadsTableCsvData(csvRows);
        } catch (error) {
            console.error("Error generating source of leads table CSV:", error);
            props?.setSnackInfo("Error generating source of leads table CSV", "error");
        }
    };

    // Generate CSV data when sourceOfLeadsData changes
    useEffect(() => {
        if (sourceOfLeadsData && sourceOfLeadsData.length > 0 && sourceOfLeadsData[0]?.monthlyData) {
            generateSourceOfLeadsTableCsv();
        }
    }, [sourceOfLeadsData]);

    const isMarketingAnalyst = userDetails.roles.some(
        (user) => user.name === ROLENAME.marketingAnalyst
    )

    // Small derived stats shown as chips above the table - purely cosmetic,
    // computed from the same sourceOfLeadsData already in state.
    const grandTotalRow = sourceOfLeadsData.find((s) => s.sourceType === "Grand Total");
    const totalLeadsCount = grandTotalRow?.grandTotal || 0;
    const totalSourcesCount = Math.max(sourceOfLeadsData.length - 1, 0);
    const monthsSpanCount = sourceOfLeadsData[0]?.monthlyData?.length || 0;

    const filteredLeads = popMonthData.filter((lead) =>
        (lead.lead_no + "").includes(search) ||
        (lead.customerId?.name || "").toLowerCase().includes(search.toLowerCase())
    );

    const paginatedData = filteredLeads?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div className={classes.pageRoot}>
            <div className={classes.headerBanner}>
                <div className={classes.headerIconWrap}>
                    <SourceIcon style={{ color: "#fff", fontSize: 28 }} />
                </div>
                <div>
                    <Typography className={classes.headerTitle}>Source of Leads Dashboard</Typography>
                    <Typography className={classes.headerSubtitle}>Track lead volume by source, month and experience center</Typography>
                </div>
            </div>

            <Card elevation={0} className={classes.filterCard}>
                <CardContent>

                    {/* HEADER */}
                    <Typography className={classes.sectionLabel}>
                        <FilterListIcon style={{ fontSize: 16 }} /> Filters
                        {loading && (
                            <Chip
                                size="small"
                                // Chip takes `icon`, not `startIcon` (that's a Button
                                // prop). The negative right margin undoes MUI's
                                // default icon spacing, sized for a glyph not a spinner.
                                icon={
                                    <CircularProgress
                                        size={11}
                                        thickness={6}
                                        style={{ color: ORANGE_DARK, marginLeft: 8, marginRight: -2 }}
                                    />
                                }
                                label="Fetching data…"
                                className={classes.loadingChip}
                            />
                        )}
                    </Typography>

                    {/* Reserved slot - keeps the filter card a fixed height so
                        the whole page doesn't shift when a fetch starts. */}
                    <div className={classes.progressSlot}>{loading ? <BrandLinearProgress /> : null}</div>

                    {/* ROW 1 */}
                    <Grid
                        container
                        spacing={3}
                        alignItems="center"
                        className={classes.filterBlock}
                        // Every control is individually disabled too; this also
                        // stops clicks landing in the gaps between them.
                        style={{ opacity: loading ? 0.55 : 1, pointerEvents: loading ? "none" : "auto" }}
                    >

                        {/* Location */}
                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                multiple
                                disabled={loading}
                                value={selectedLocation}
                                onChange={handleMultipleLocationData}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField {...params} className={classes.roundedField} label="Location" variant="outlined" size="small" />
                                )}
                            />
                        </Grid>

                        {/* Experience Center */}
                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                multiple
                                disabled={loading}
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField {...params} className={classes.roundedField} label="Experience Center" variant="outlined" size="small" />
                                )}
                            />
                        </Grid>

                        {/* Date Type */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                select
                                label="Date Type"
                                name="dateType"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                className={classes.roundedField}
                                value={storeDateFilter.dateType}
                                onChange={storePivotDate}
                                fullWidth
                            >
                                <MenuItem value="leadAssignedDate">Lead Assigned</MenuItem>
                                <MenuItem value="createdAt">Created Date</MenuItem>
                            </TextField>
                        </Grid>

                        {/* From */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                type="date"
                                label="From"
                                name="startDate"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                className={classes.roundedField}
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        {/* To */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                type="date"
                                label="To"
                                name="endDate"
                                disabled={loading}
                                size="small"
                                variant="outlined"
                                className={classes.roundedField}
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        {/* Submit */}
                        <Grid item xs={12} md={2}>
                            <Button
                                fullWidth
                                size="small"
                                onClick={handlePivotDateFilter}
                                disabled={loading}
                                className={classes.pillButton}
                                startIcon={loading ? <CircularProgress size={15} color="inherit" /> : null}
                                style={{
                                    background: loading
                                        ? "#c9d0db"
                                        : "linear-gradient(135deg, #F47E46 0%, #f2994a 100%)",
                                    color: "#fff",
                                    height: "40px",
                                }}
                            >
                                {loading ? "Loading…" : "Submit"}
                            </Button>
                        </Grid>
                    </Grid>

                    {/* ROW 2 */}
                    <Typography className={classes.sectionLabel} style={{ marginTop: 22 }}>
                        <TrendingUpIcon style={{ fontSize: 16 }} /> Lead Status
                    </Typography>
                    <Grid
                        container
                        spacing={3}
                        alignItems="center"
                        className={classes.filterBlock}
                        style={{ opacity: loading ? 0.55 : 1, pointerEvents: loading ? "none" : "auto" }}
                    >

                        {/* Move to Marketing */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                select
                                label="Move to Marketing"
                                disabled={loading}
                                variant="outlined"
                                size="small"
                                fullWidth
                                className={classes.roundedField}
                                value={selectedValue}
                                onChange={(e) => handleSelectChange(e)}
                            >
                                <MenuItem value="2">All</MenuItem>
                                <MenuItem value="1">YES (M2M, TBC, Hold, Junk)</MenuItem>
                                <MenuItem value="0">NO (SQL)</MenuItem>
                                <MenuItem value="3">AI Verification Pending (MQL, MNQL, Direct)</MenuItem>
                            </TextField>
                        </Grid>

                        {/* Lead Mode */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                select
                                label="Lead Mode"
                                disabled={loading}
                                variant="outlined"
                                size="small"
                                fullWidth
                                className={classes.roundedField}
                                value={leadMode}
                                onChange={(e) => handleLeadMode(e)}
                            >
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="Automation">Automation Leads</MenuItem>
                                <MenuItem value="Manual">Manual Leads</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <div>
                <Card elevation={0} className={classes.dashboardCard}>
                    <div className={classes.dashboardCardHeader}>
                        <div className={classes.dashboardCardTitle}>
                            <BarChartIcon style={{ color: "#fff" }} />
                            Source Type Dashboard
                        </div>

                        {/* RIGHT: Buttons */}
                        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>

                            {/* Refresh Button */}
                            <Button
                                onClick={handleRefreshClick}
                                variant="contained"
                                className={classes.pillButton}
                                startIcon={<RefreshIcon className={isSpinning ? classes.spinningIcon : undefined} />}
                                disabled={isDisabled}
                                style={{
                                    background: isDisabled ? "#8593a8" : "linear-gradient(135deg, #F47E46 0%, #f2994a 100%)",
                                    color: "#fff",
                                    height: "36px",
                                }}
                            >
                                {isDisabled
                                    ? `Wait (${formatTimeLeft()})`
                                    : "Fetch New Data"}
                            </Button>

                            {/* Hidden CSV */}
                            <CSVLink
                                data={sourceOfLeadsTableCsvData}
                                filename={`Source_of_Leads_${moment().format('YYYY-MM-DD')}.csv`}
                                ref={sourceOfLeadsTableCsvButtonRef}
                                style={{ display: 'none' }}
                            />

                            {/* Download Button */}
                            <Button
                                variant='contained'
                                size="small"
                                className={classes.pillButton}
                                startIcon={<DownloadOutlined />}
                                style={{
                                    background: "linear-gradient(135deg, #27ae60 0%, #219150 100%)",
                                    color: "#fff",
                                    height: "36px",
                                }}
                                onClick={() => {
                                    generateSourceOfLeadsTableCsv();
                                    setTimeout(() => {
                                        if (
                                            sourceOfLeadsTableCsvButtonRef.current &&
                                            sourceOfLeadsTableCsvData.length > 0
                                        ) {
                                            sourceOfLeadsTableCsvButtonRef.current.link.click();
                                        }
                                    }, 200);
                                }}
                            >
                                Download CSV
                            </Button>

                        </div>
                    </div>

                    {/* STATS STRIP - skeletons while loading rather than an
                        empty gap, so the card keeps its height. */}
                    {loading && (
                        <div className={classes.statsStrip}>
                            {[0, 1, 2].map((i) => (
                                <div key={i} className={classes.statChip}>
                                    <Skeleton variant="circle" width={34} height={34} />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton variant="text" width={64} height={20} />
                                        <Skeleton variant="text" width={82} height={12} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    {!loading && sourceOfLeadsData.length > 0 && (
                        <div className={classes.statsStrip}>
                            <div className={classes.statChip}>
                                <div className={classes.statChipIcon} style={{ background: "#e8f1fd" }}>
                                    <AssignmentIcon style={{ color: "#1976d2", fontSize: 18 }} />
                                </div>
                                <div>
                                    <div className={classes.statChipValue}>{totalLeadsCount.toLocaleString()}</div>
                                    <div className={classes.statChipLabel}>Total Leads</div>
                                </div>
                            </div>
                            <div className={classes.statChip}>
                                <div className={classes.statChipIcon} style={{ background: "#fef3e6" }}>
                                    <CategoryIcon style={{ color: "#f2994a", fontSize: 18 }} />
                                </div>
                                <div>
                                    <div className={classes.statChipValue}>{totalSourcesCount}</div>
                                    <div className={classes.statChipLabel}>Lead Sources</div>
                                </div>
                            </div>
                            <div className={classes.statChip}>
                                <div className={classes.statChipIcon} style={{ background: "#e9f9ef" }}>
                                    <DateRangeIcon style={{ color: "#27ae60", fontSize: 18 }} />
                                </div>
                                <div>
                                    <div className={classes.statChipValue}>{monthsSpanCount}</div>
                                    <div className={classes.statChipLabel}>Months Covered</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* TABLE */}
                    <div>
                        {/* Visible even when the filter card has scrolled away. */}
                        <div className={classes.progressSlot} style={{ margin: "0 16px 10px" }}>
                            {loading ? <BrandLinearProgress /> : null}
                        </div>

                        {/* Same banner the leads-generated dashboard uses - the bar
                            above shows that something is happening, this says what.
                            Horizontal margin matches the progress slot so the two
                            line up with the table edge. */}
                        {loading && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    margin: "0 16px 12px",
                                    padding: "10px 14px",
                                    borderRadius: 10,
                                    background: "#FFF4ED",
                                    border: "1px solid #f6d3bd",
                                }}
                            >
                                <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: ORANGE_DARK }}>
                                        Fetching lead data…
                                    </div>
                                    <div style={{ fontSize: 11.5, color: "#7a6a60" }}>
                                        Building the source-by-month breakdown — this can take a few seconds on a wide date range.
                                    </div>
                                </div>
                            </div>
                        )}
                        <TableContainer className={classes.tableScrollArea}>
                            <Table
                                stickyHeader
                                style={{
                                    borderCollapse: "collapse",
                                    width: "100%"
                                }}
                            >

                                {/* HEADER */}
                                <TableHead>
                                    <TableRow>

                                        <TableCell style={headerStyle}>
                                            Month And Year
                                        </TableCell>

                                        {sourceOfLeadsData?.map((source, index) => (
                                            <TableCell key={index} style={headerStyle}>
                                                <div style={iconHeaderStyle}>
                                                    <Tooltip title={`${source.sourceType}`} placement="top">
                                                        <span style={{ cursor: "pointer" }}>
                                                            {source.sourceType}
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                {/* BODY */}
                                <TableBody>
                                    {loading ? (
                                        // Placeholder rows shaped like the real
                                        // grid, so the table keeps its height and
                                        // column rhythm instead of collapsing to a
                                        // single spinner and snapping back.
                                        // Falls back to 6 columns on a first load,
                                        // when sourceOfLeadsData is still empty.
                                        Array.from({ length: 7 }).map((_, r) => (
                                            <TableRow key={r}>
                                                {Array.from({
                                                    length: (sourceOfLeadsData.length || 5) + 1,
                                                }).map((__, c) => (
                                                    <TableCell key={c} style={{ padding: "14px 10px" }}>
                                                        <Skeleton
                                                            variant="text"
                                                            width={c === 0 ? 96 : 44}
                                                            style={c === 0 ? undefined : { margin: "0 auto" }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <>
                                            {/* MONTH ROWS */}
                                            {sourceOfLeadsData[0]?.monthlyData?.map((month, i) => (
                                                <TableRow key={i} style={rowStyle}>

                                                    {/* MONTH */}
                                                    <TableCell style={monthCellStyle}>
                                                        <strong>{`${month.monthName.slice(0, 3)}-${month.year % 100}`}</strong>
                                                    </TableCell>

                                                    {/* DATA */}
                                                    {sourceOfLeadsData.map((source, idx) => {
                                                        const data = source.monthlyData.find(
                                                            (m) =>
                                                                m.monthName === month.monthName &&
                                                                m.year === month.year
                                                        );

                                                        return (
                                                            <TableCell
                                                                key={idx}
                                                                style={cellStyle}
                                                                onClick={(e) =>
                                                                    getDataBasedOnClickSourceOfLeads(
                                                                        e,
                                                                        month,
                                                                        source,
                                                                        data?.leadIds || [],
                                                                        "leads"
                                                                    )
                                                                }
                                                            >
                                                                <span
                                                                    className={classes.countBadge}
                                                                    style={
                                                                        data?.createdCount
                                                                            ? { background: "#e8f1fd", color: "#1976d2" }
                                                                            : { background: "transparent", color: "#c3cbd9" }
                                                                    }
                                                                >
                                                                    {data?.createdCount || 0}
                                                                </span>
                                                            </TableCell>
                                                        );
                                                    })}

                                                </TableRow>
                                            ))}

                                            {/* GRAND TOTAL */}
                                            <TableRow style={totalRowStyle}>
                                                <TableCell style={totalMonthCellStyle}>
                                                    <strong>Grand Total</strong>
                                                </TableCell>

                                                {sourceOfLeadsData.map((source, i) => (
                                                    <TableCell
                                                        key={i}
                                                        style={totalCellStyle}
                                                        onClick={(e) =>
                                                            getDataBasedOnClickSourceOfLeads(
                                                                e,
                                                                sourceOfLeadsData[0].monthlyData,
                                                                source,
                                                                source.leadIds || [],
                                                                "total"
                                                            )
                                                        }
                                                    >
                                                        {formatNumberToTwoDecimalPlaces(
                                                            source.monthlyData.reduce(
                                                                (sum, d) => sum + d.createdCount,
                                                                0
                                                            )
                                                        )}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Card>
            </div>


            <Modal
                open={showDetailedModal}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
            >
                <Fade in={showDetailedModal}>
                    <div
                        style={{
                            width: "95%",
                            height: "90vh",
                            margin: "auto",
                            marginTop: "2%",
                            background: "#fff",
                            borderRadius: 12,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* HEADER */}
                        <div
                            style={{
                                padding: "15px 20px",
                                background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div>
                                <Typography style={{ fontWeight: 600 }}>
                                    {selectedTitle}
                                </Typography>
                                <Typography
                                    style={{
                                        fontSize: 12,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        color: "rgba(255,255,255,0.85)",
                                    }}
                                >
                                    {modalDataLoading ? (
                                        <>
                                            <CircularProgress size={11} thickness={6} style={{ color: "#fff" }} />
                                            Fetching leads, please wait…
                                        </>
                                    ) : (
                                        // Once a search is on, say which number is which -
                                        // "12 leads found" while 48 were fetched reads as
                                        // data having gone missing.
                                        `${search.trim()
                                            ? `${filteredLeads.length} of ${popMonthData?.length || 0}`
                                            : popMonthData?.length || 0
                                        } lead${(search.trim() ? filteredLeads.length : popMonthData?.length || 0) === 1 ? "" : "s"} found`
                                    )}
                                </Typography>
                            </div>

                            <div style={{ display: "flex", gap: 10 }}>
                                <CSVLink
                                    headers={headers}
                                    filename={`${selectedTitle}.csv`}
                                    data={csvData}
                                    ref={csvButtonRef}
                                />
                                {!isMarketingAnalyst &&
                                    <Button
                                        variant="contained"
                                        disabled={modalDataLoading || popMonthData.length === 0}
                                        startIcon={modalDataLoading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <GetAppIcon />}
                                        onClick={() => csvDownloadHandler(popMonthData)}
                                        className={classes.pillButton}
                                        style={{
                                            // Muted while disabled - a full-strength
                                            // green button that does nothing is worse
                                            // than an obviously inactive one.
                                            background: (modalDataLoading || popMonthData.length === 0)
                                                ? "#c9d0db"
                                                : "linear-gradient(135deg, #27ae60 0%, #219150 100%)",
                                            color: "#fff",
                                        }}
                                    >
                                        {modalDataLoading ? "Loading…" : "Export"}
                                    </Button>
                                }
                                <IconButton
                                    onClick={handleCloseModal}
                                    style={{ color: "#fff" }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>

                        {/* Reserved slot so the search row doesn't shift when the
                            modal starts fetching. */}
                        <div className={classes.progressSlot} style={{ margin: "0 15px" }}>
                            {modalDataLoading ? <BrandLinearProgress /> : null}
                        </div>

                        {/* Says plainly what is happening, next to the search box
                            the user has just been locked out of. The skeleton rows
                            below show shape but not intent - this supplies it. */}
                        {modalDataLoading && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    margin: "0 15px 12px",
                                    padding: "10px 14px",
                                    borderRadius: 10,
                                    background: "#EEF4FD",
                                    border: "1px solid #cfe0f7",
                                }}
                            >
                                <CircularProgress size={17} thickness={5} style={{ color: "#2a5ea8" }} />
                                <div style={{ minWidth: 0 }}>
                                    <Typography style={{ fontSize: 13, fontWeight: 700, color: "#1C375D" }}>
                                        Loading leads for {selectedTitle}…
                                    </Typography>
                                    <Typography style={{ fontSize: 11.5, color: "#5c6779" }}>
                                        Pulling every lead behind this number — this can take a few seconds on a wide date range.
                                    </Typography>
                                </div>
                            </div>
                        )}

                        {/* SEARCH */}
                        <div style={{ padding: "0 15px 15px" }}>
                            <TextField
                                placeholder={modalDataLoading ? "Search available once leads load…" : "Search leads..."}
                                variant="outlined"
                                size="small"
                                disabled={modalDataLoading}
                                className={classes.roundedField}
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(0);
                                }}
                                style={{ width: 300 }}
                            />
                        </div>

                        {/* TABLE */}
                        <div style={{ flex: 1, overflow: "auto" }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {MODAL_COLUMNS.map((head, i) => (
                                            <TableCell
                                                key={i}
                                                style={{
                                                    background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
                                                    color: "#fff",
                                                    fontWeight: 600,
                                                    border: "1px solid #dcdcdc",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {head}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {modalDataLoading ? (
                                        // Placeholder rows across all 18 columns,
                                        // so the wide table keeps its shape while
                                        // loading instead of collapsing to one cell.
                                        Array.from({ length: 8 }).map((_, r) => (
                                            <TableRow key={r}>
                                                {MODAL_COLUMNS.map((__, c) => (
                                                    <TableCell key={c} style={{ padding: "12px 8px", border: "none" }}>
                                                        <Skeleton variant="text" width={c === 0 ? 62 : 54} />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : paginatedData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={MODAL_COLUMNS.length} align="center" style={{ padding: 40, border: "none", color: "#8593a8" }}>
                                                <AssignmentIcon style={{ fontSize: 36, color: "#cbd5e1" }} />
                                                <Typography style={{ marginTop: 8, fontWeight: 600, color: "#64748b" }}>
                                                    {search.trim()
                                                        ? `No leads match “${search.trim()}”`
                                                        : "No leads found for this selection"}
                                                </Typography>
                                                <Typography style={{ fontSize: 12.5, color: "#94a3b8", marginTop: 2 }}>
                                                    {search.trim()
                                                        ? "Search looks at the lead number and the client name."
                                                        : "Try a different month, source or date range."}
                                                </Typography>
                                                {search.trim() && (
                                                    <Button size="small" onClick={() => { setSearch(""); setPage(0); }} style={{ marginTop: 6 }}>
                                                        Clear search
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ) : paginatedData.map((data, index) => (
                                        <TableRow
                                            key={index}
                                            style={{
                                                background: index % 2 === 0 ? "#fafafa" : "#fff"
                                            }}
                                        >
                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.erpProjectNo || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                <Link
                                                    to={`/project-logs/${data?._id}`}
                                                    target="_blank"
                                                    style={{
                                                        color: "#1e3a8a",
                                                        textDecoration: "underline"
                                                    }}
                                                >
                                                    {data?.lead_no || "NA"}
                                                </Link>
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.createdAt ? formatDate(data.createdAt) : "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadAssignedDate ? formatDate(data.leadAssignedDate) : "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.customerId?.name || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.sourceOfLead?.name || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {formatSecondarySources(data)}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.sourceOfLead?.sourceType || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.staticSalesWonBudget || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.experienceCenterId?.locationId?.name || "Others"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.experienceCenterId?.name || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {getProposeMeetingDate(data)
                                                    ? formatDate(getProposeMeetingDate(data))
                                                    : "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadWonDate
                                                    ? formatDate(data.leadWonDate)
                                                    : "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.departmentId?.name || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.currentStage || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadType || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.junkReason || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.moveToMarketingReason || "NA"}
                                            </TableCell>

                                            <TableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.moveToMarketingOtherReason || "NA"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>

                        {/* FOOTER */}
                        <div
                            style={{
                                padding: 10,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <Typography style={{ fontSize: 12 }}>
                                Showing {page * rowsPerPage + 1} -{" "}
                                {Math.min((page + 1) * rowsPerPage, popMonthData.length)} of{" "}
                                {popMonthData.length}
                            </Typography>

                            <div>
                                <IconButton
                                    disabled={page === 0}
                                    onClick={() => setPage((p) => p - 1)}
                                >
                                    <ArrowBackIosIcon fontSize="small" />
                                </IconButton>

                                <span style={{ margin: "0 10px" }}>
                                    Page {page + 1} of {Math.ceil(popMonthData.length / rowsPerPage)}
                                </span>

                                <IconButton
                                    disabled={(page + 1) * rowsPerPage >= popMonthData.length}
                                    onClick={() => setPage((p) => p + 1)}
                                >
                                    <ArrowForwardIosIcon fontSize="small" />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(SourceOfLeadsDashboard);